<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="请输入人体图名进行搜索，可以直接回车搜索..." prefix-icon="el-icon-search"
                              clearable
							  size="medium"
                              @clear="initEmps"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initEmps" :disabled="showAdvanceSearchView"></el-input>
					<el-select v-model="bodyModel" placeholder="所属单元" clearable style="margin-right: 10px" @change="bodyModelChange()">
					    <el-option
					      v-for="item in bodyModels"
					      :key="item.kbmId"
					      :label="item.kbmName"
					      :value="item.kbmId">
					    </el-option>	
					</el-select>
                    <el-button icon="el-icon-search" type="primary" @click="initEmps" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
                </div>
                <div>
					<!-- <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
					    添加单元类型
					</el-button> -->
                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加单元
                    </el-button>
                </div>
            </div>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    :data="emps"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    style="width: 100%">
                <!-- <el-table-column
                        type="selection"
                        width="55">
                </el-table-column> -->
				<el-table-column
				        prop="khbmCode"
				        align="center"
				        label="所属单元类型"
						min-width="20%"
				        >
						<template slot-scope="scope">
							<div>{{getBodyModelNameById(scope.row.khbmBodyModel,bodyModels)}}</div>
						</template>
				</el-table-column> 
				<el-table-column
				        prop="khbmCode"
				        align="center"
				        label="单元编号"
				        min-width="20%">
				</el-table-column> 
                <el-table-column
                        prop="khbmName"
                        align="center"
                        label="单元名称"
                        min-width="20%">
                </el-table-column>       
				 <el-table-column
						 prop="khbmName"
						 align="center"
						 label="附件"
						 min-width="20%">
						 <template slot-scope="scope">
							 <div class="image_warp">
								 <el-image style="width: 100%; height: 100%" 
								 :src="showAttach(scope.row.khbmFilePath)"
								 :preview-src-list="previewAttach(scope.row.khbmFilePath)"
								 ></el-image>
							 </div>
						 </template>
				 </el-table-column>   
                <el-table-column
						align="center"
						min-width="20%"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
				:before-close="handleClose"
                width="80%">
            <div>
                <el-form :model="emp" :rules="rules" ref="empForm">
					<el-row>
					    <el-col :span="7">
							<el-form-item label="单元类型:" prop="khbmBodyModel">
								<el-select v-model="emp.khbmBodyModel" placeholder="请选择所属单元类型" clearable style="margin-right: 10px">
									<el-option
									  v-for="item in bodyModels"
									  :key="item.kbmId"
									  :label="item.kbmName"
									  :value="item.kbmId">
									</el-option>	
								</el-select>
							</el-form-item>
					    </el-col>
					</el-row>

                    <el-row>
                        <el-col :span="7">
                            <el-form-item label="单元编号:" prop="khbmCode">
								<div class="input_box">
									<el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.khbmCode"
									          placeholder="请输入编号" maxlength="50" show-word-limit></el-input>
								</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="7">
                            <el-form-item label="单元名称:" prop="khbmName">
								<div class="input_box">
									<el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.khbmName"
									          placeholder="请输入名称" maxlength="50" show-word-limit></el-input>
								</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="7">
                            <el-form-item label="单元照片:" prop="khbmFilePath">
								<div class="input_box">
									<el-upload
									  class="upload-demo"
									  action="/upgrade/humanBody/basic/upload"
									  :on-preview="handlePreview"
									  :on-remove="handleRemove"
									  :before-remove="beforeRemove"
									  :on-success="onUploadSuccess" :on-error="onUploadError"
									  multiple
									  :limit="1"
									  :on-exceed="handleExceed"
									  :file-list="fileList">
									  <el-button size="small" type="primary">点击上传</el-button>
	<!-- 								  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
									</el-upload>
								</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="doAddEmp">确 定</el-button>
			  </span>
        </el-dialog>
	</div>
</template>

<script>
	//所需页面导入
	import vue from 'vue'
	import QRCode from 'qrcodejs2'
    export default {
        name: "Tenants",
        data() {
            return {
                searchValue: {
					ktiContacts:'',
					ktiContactWay:'',
					ktiIsEnable:''
                },
                title: '',
				showAdvanceSearchView: false,
                allDeps: [],
                emps: [],
                loading: false,
                dialogVisible: false,
				qrcodeDialogVisible:false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
                emp: {
					khbmId:'',
					khbmBodyModel:'',
					khbmCode:'',
					khbmName:'',
					khbmFilePath:''
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rules: {
					khbmBodyModel: [{required: true, message: '请选择所属单元类型', trigger: 'blur'}],
                    khbmCode: [{required: true, message: '请输入单元编号', trigger: 'blur'}],
					khbmName: [{required: true, message: '请输入单元名称', trigger: 'blur'}],
					khbmFilePath: [{required: true, message: '请上传单元照片', trigger: 'blur'}]
                },
				fileList:[],
				bodyModels:[],
				bodyModel:''
            }
        },
        mounted() {
            this.initEmps();
            this.initData();
        },
        methods: {
			getBodyModelNameById(id,arr){
				console.log(id,arr)
				var temp = ''
				for (var index in arr) {
					if(arr[index].kbmId == id){
						temp = arr[index].kbmName
					}
				}
				return temp
			},
			previewAttach(path){
				path = path.replaceAll('/home/tea/attach/','')
				return ['https://bjzjsy.com/attach/'+path]
			},
			showAttach(path){
				path = path.replaceAll('/home/tea/attach/','')
				return 'https://bjzjsy.com/attach/' + path
			},
			onUploadSuccess(res){
				console.log(res)
				console.log(this.fileList)
				this.emp.khbmFilePath = res.obj
			},
			onUploadError(res){
				console.log(res)
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handleClose(done) {
				console.log("handleClose")
				this.dialogVisible = false
				this.emptyEmp()
			},
            emptyEmp() {
                this.emp = {
					khbmId:'',
                    khbmCode:'',
                    khbmName:'',
					khbmFilePath:''
                }
				this.fileList = []
            },
            showEditEmpView(data) {
				console.log(data)
				var fileName = data.khbmFilePath.substring( data.khbmFilePath.lastIndexOf("/") + 1 )
				this.fileList = [{name: fileName, url:data.khbmFilePath}];
                this.title = '编辑单元信息';
                this.emp = data;
                this.dialogVisible = true;
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除【' + data.khbmName + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/humanBody/basic/del/" + data.khbmId).then(resp => {
                        if (resp) {
                            this.initEmps();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            doAddEmp() {
				console.log(this.emp)
                if (this.emp.khbmId) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/humanBody/basic/update", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
									this.emptyEmp();
                                    this.initEmps();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/humanBody/basic/add", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
									this.emptyEmp();
                                    this.initEmps();
                                }
                            })
                        }
                    });
                }
            },
            initData() {
				
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加单元信息';
                this.dialogVisible = true;
            },
            initEmps() {
                this.loading = true;
                let url = '/humanBody/basic/getHumanBodys?page=' + this.page + '&size=' + this.size + '&keyword=' + this.keyword;
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                    }
                });
				
				this.getRequest('/humanBody/basic/getBodyModels').then(resp => {
				    this.loading = false;
				    if (resp.status == 200) {
				        this.bodyModels = resp.obj;
				    }
				});
            },
			bodyModelChange(){
				this.page = 1
				this.initEmps();
			}
        }
    }
</script>

<style scoped lang="scss">
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
	.el-form-item {
		display: flex;
		.input_box {
			width: 14.5rem;
			.el-input {
				width: 100% !important;
			}
		}
	}
	.advance_seit_box {
		line-height: 2.5rem;
		height: 2.5rem;
		font-size: 0.875rem;
		.box_tit {
			font-size: 0.875rem;
		}
	}
	.advance_btn_warp {
		line-height: 2.5rem;
		height: 2.5rem;
	}
	::v-deep .el-form-item__label {
		min-width: 100px;
	}
	.image_warp {
		width: 40px;
		height: 40px;
		margin: 0 auto;
		cursor: pointer;
		img {
			width: 100%;
			height: 100%;
		}
	}
</style>
